import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { storableError } from '../../util/errors';
import { HOME_OPPORTUNITIES, opportunityQuery } from './homeOpportunities';

export const ASSET_NAME = 'landing-page';
const REQUEST = 'app/LandingPage/FETCH_RECENT_REQUEST';
const SUCCESS = 'app/LandingPage/FETCH_RECENT_SUCCESS';
const ERROR = 'app/LandingPage/FETCH_RECENT_ERROR';

const initialState = { recentByCategory: {} };

export default function landingPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  if (![REQUEST, SUCCESS, ERROR].includes(type)) return state;
  const { key } = payload;
  const category =
    type === REQUEST
      ? { loading: true, id: null, error: null }
      : type === SUCCESS
      ? { loading: false, id: payload.id, error: null }
      : { loading: false, id: null, error: payload.error };
  return { ...state, recentByCategory: { ...state.recentByCategory, [key]: category } };
}

const fetchRecent = category => async (dispatch, getState, sdk) => {
  const { key } = category;
  dispatch({ type: REQUEST, payload: { key } });
  try {
    const query = opportunityQuery(category);
    let page = 1;
    let id = null;
    // Investment-only is narrower than the indexed has_any filter. Walk the
    // ordered results until a match, rather than hiding older eligible mandates.
    do {
      const response = await sdk.listings.query(
        key === 'invest' ? { ...query, per_page: 100, page } : query
      );
      const listing = response.data.data.find(item => {
        if (key !== 'invest') return true;
        const operations = item.attributes?.publicData?.tiposOperacion;
        return (
          Array.isArray(operations) &&
          !operations.includes('venta-total') &&
          category.operations.some(operation => operations.includes(operation))
        );
      });
      if (listing) {
        dispatch(addMarketplaceEntities(response));
        id = listing.id;
        break;
      }
      if (key !== 'invest' || page >= (response.data.meta?.totalPages || 1)) break;
      page += 1;
    } while (true);
    dispatch({ type: SUCCESS, payload: { key, id } });
  } catch (e) {
    dispatch({ type: ERROR, payload: { key, error: storableError(e) } });
  }
};

/** Independent requests keep one failed category from hiding the rest of the marketplace. */
export const loadData = () => dispatch =>
  Promise.all(HOME_OPPORTUNITIES.map(category => dispatch(fetchRecent(category))));
